// Lib
import { useSnackbar } from 'notistack'
import React, { useEffect } from 'react'
import { useAuth } from '../../hooks/use-auth'
import { useRouter } from '../../hooks/use-router'
import { mutate } from 'swr'
// Mobile integration
import { useCapacitorEvents } from '../../mobile'
import BassistNotification from '../Notifications/BassistNotification'

/**
 * Listens for notification events from capacitor
 */
export default function NotificationsNative() {
  const payload = useCapacitorEvents('pushNotification')
  const actionPayload = useCapacitorEvents('pushNotificationAction')

  const notifier = useSnackbar()
  const auth = useAuth()
  const router = useRouter()

  useEffect(() => {
    mutate('/getMessageCount')

    // Payload required
    if (!payload || !payload.data) return

    notifier.enqueueSnackbar(payload.data.title, {
      content: (key, _) => (
        <BassistNotification
          style={{ background: 'red' }}
          id={key}
          notificationPayload={payload.data}
          message={payload.data.title}
          config={{ auth, router }}
        />
      ),
      autoHideDuration: 20000,
      dense: 'true',
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [payload])

  useEffect(() => {
    mutate('/getMessageCount')

    // Payload required
    if (!actionPayload || !actionPayload.data) return

    notifier.enqueueSnackbar(actionPayload.data.title, {
      content: (key, _) => (
        <BassistNotification
          style={{ background: 'red' }}
          id={key}
          notificationPayload={actionPayload.data}
          message={actionPayload.data.title}
          config={{ auth, router }}
        />
      ),
      autoHideDuration: 20000,
      dense: 'true',
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actionPayload])

  return null
}
